export const CONTACT_SEARCH_FORM = 'contact';
export const NOT_FOUND_HEADER_COPY = 'We did not find your client in our records.';
export const REGULAR_HEADER_COPY = 'Please fill out your client\'s basic contact information below.';
